import React, { useContext } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { AuthContext } from "./context/Authcontext";
import Main from "./pages/Main";
import Galeria from "./pages/Galeria";
import PlanosContato from "./pages/PlanosContato";
import Admin from "./pages/Admin";
import VisualizarAlbum from "./pages/VisualizarAlbum";
import Configuracoes from "./pages/Configuracoes";
import IntegracaoFacebook from "./pages/IntegracaoFacebook";
import GerenciarPublicacoes from "./pages/GerenciarPublicacoes";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { token } = useContext(AuthContext);
  return (
    <Route
      {...rest}
      render={(props) =>
        token ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: "/admin", state: { from: props.location } }}
          />
        )
      }
    />
  );
};

function Routes() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={Main} />
        <Route path="/galeria" component={Galeria} />
        <Route path="/planos-contato" component={PlanosContato} />
        <Route path="/admin" component={Admin} />
        <Route path="/visualizar-album/:idAlbum" component={VisualizarAlbum} />
        <PrivateRoute path="/configuracoes/publicacoes" component={GerenciarPublicacoes} />
        <PrivateRoute path="/configuracoes" component={Configuracoes} />
        <PrivateRoute path="/integracao-facebook" component={IntegracaoFacebook} />
        <Route path="*" component={Main} />
      </Switch>
    </BrowserRouter>
  );
}

export default Routes;
